import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #DROPDOWN-PANEL
\*------------------------------------ */
/**
 * 1) Dropdown panel
 */
.cat-c-dropdown-panel {
  background-color: var(--cat-dropdown-panel-background-color, var(--cat-theme-color-background-default));
  box-shadow: var(--cat-panel-box-shadow, var(--cat-theme-box-shadow-lg));
  border-start-start-radius: var(--cat-dropdown-panel-border-block-start-left-radius, var(--cat-border-radius-lg));
  border-start-end-radius: var(--cat-dropdown-panel-border-block-start-right-radius, var(--cat-border-radius-lg));
  border-end-end-radius: var(--cat-dropdown-panel-border-block-end-right-radius, var(--cat-border-radius-lg));
  border-end-start-radius: var(--cat-dropdown-panel-border-block-end-left-radius, var(--cat-border-radius-lg));
  height: var(--cat-dropdown-panel-height, auto);
  z-index: var(--cat-z-index-400);
  transform: translateY(var(--cat-dropdown-panel-transform, 0));
  min-height: var(--cat-dropdown-panel-min-height, 0);
  --cat-dropdown-checkbox-checked-background: var(--cat-theme-color-background-subtle);
}

/**
 * Give padding and border styling to panel body
 */
.cat-c-dropdown-panel__body {
  position: var(--cat-dropdown-panel-body-position, relative);
  padding: var(--cat-c-dropdown-panel-body-padding, var(--cat-space-3x-small) 0);
  border-start-start-radius: var(--cat-dropdown-panel-border-block-start-left-radius, var(--cat-border-radius-lg));
  border-start-end-radius: var(--cat-dropdown-panel-border-block-start-right-radius, var(--cat-border-radius-lg));
  border-end-end-radius: var(--cat-dropdown-panel-border-block-end-right-radius, var(--cat-border-radius-lg));
  border-end-start-radius: var(--cat-dropdown-panel-border-block-end-left-radius, var(--cat-border-radius-lg));
  border: var(--cat-dropdown-panel-border, var(--cat-theme-border-width)) solid var(--cat-dropdown-panel-border-color, var(--cat-theme-color-border-default));
  height: var(--cat-dropdown-panel-body-height, auto);
  max-height: var(--cat-auto-position-max-height);
  max-width: var(--cat-auto-position-max-width);
  overflow: var(--cat-auto-position-overflow);
  /**
  * Dropdown panel body within bare variant
  * 1) "Remove" the border without adjusting the width in case this needs to have the
  * same size as default bordered version
  */
  /**
  * Change border radius on body container if header is present
  */
  /**
  * Change border radius on body container if footer is present
  */
  /**
  * Adds a max height and scrolling of the panel
  */
}
.cat-c-dropdown-panel--bare .cat-c-dropdown-panel__body {
  border-color: transparent; /* 1 */
}
.cat-has-header .cat-c-dropdown-panel__body {
  border-radius: 0 0 var(--cat-border-radius-lg) var(--cat-border-radius-lg);
}
.cat-has-footer .cat-c-dropdown-panel__body {
  border-radius: var(--cat-border-radius-lg) var(--cat-border-radius-lg) 0 0;
}
.cat-has-scroll .cat-c-dropdown-panel__body {
  overflow: auto;
  max-height: var(--cat-auto-position-max-height, var(--cat-dropdown-panel-body-max-height, calc(var(--size-base-unit) * 20)));
}

/**
 * Optional dropdown panel header
 */
.cat-c-dropdown-panel__header {
  padding: var(--cat-space-x-small);
  border: var(--cat-theme-border-width) solid var(--cat-dropdown-panel-border-color, var(--cat-theme-color-border-default));
  border-radius: var(--cat-border-radius-lg) var(--cat-border-radius-lg) 0 0;
  margin-block-end: -1px;
}

/**
 * Dropdown panel footer
 * 1) Add padding to footer
 */
.cat-c-dropdown-panel__footer {
  padding: var(--cat-space-x-small);
}

/**
 * Dropdown with large size
 */
.cat-c-dropdown--large {
  --cat-dropdown-checkbox-padding: var(--cat-space-small) var(--cat-space-x-small) var(--cat-space-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: var(--cat-space-x-small);
  --cat-dropdown-checkbox-padding-left: calc(var(--size-base-unit) * 5.5);
}

/**
 * Dropdown with medium size
 */
.cat-c-dropdown--medium {
  --cat-dropdown-checkbox-padding: var(--cat-space-3x-small) var(--cat-space-x-small) var(--cat-space-3x-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: 0;
}

/**
 * Dropdown with small size
 */
.cat-c-dropdown--small {
  --cat-dropdown-checkbox-padding: var(--cat-space-3x-small) var(--cat-space-x-small) var(--cat-space-3x-small) var(--cat-space-3x-large);
  --cat-dropdown-checkbox-input-padding: 0;
}

.cat-c-panel {
  inset-block-end: 0;
  width: 100%;
}

.cat-c-position {
  position: absolute;
}

.cat-c-dropdown-panel:not(.cat-c-dropdown-panel--has-header) .cat-c-dropdown-panel__header, .cat-c-dropdown-panel:not(.cat-c-dropdown-panel--has-footer) .cat-c-dropdown-panel__footer {
  display: none;
}
`;
       